<div class="layout-wrapper" [ngClass]="{
    'layout-overlay': app.menuMode === 'overlay',
    'layout-static': app.menuMode === 'static',
    'layout-drawer': app.menuMode === 'drawer',
    'layout-slim': app.menuMode === 'slim',
    'layout-sidebar-dim': app.colorScheme === 'dim',
    'layout-sidebar-dark': app.colorScheme === 'dark' || (app.colorScheme === 'light' && app.menuTheme === 'layout-sidebar-dark'),
    'layout-sidebar-darkgray': app.colorScheme === 'light' && app.menuTheme === 'layout-sidebar-darkgray',
    'layout-card-filled': app.cardStyle === 'filled',
    'layout-card-transparent': app.cardStyle === 'transparent',
    'layout-overlay-active': overlayMenuActive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-sidebar-active': app.menuMode === 'drawer' && drawerMenuDesktopActive,
    'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
    'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple}"
     [attr.data-theme]="app.colorScheme" (click)="onLayoutClick()">

    <app-menu></app-menu>

    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>

        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>

    <div class="layout-mask modal-in"></div>
</div>
